"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.API_BASE_REDUCER_PATH = void 0;
var API_BASE_REDUCER_PATH = '@alycecom/services/';
exports.API_BASE_REDUCER_PATH = API_BASE_REDUCER_PATH;